import { type WebhooksAddContent, WebhooksRequester, type WebhooksUpdateContent } from '@cobliteam/api-lib';
import { useMutation, useQuery } from '@tanstack/react-query';

const webhooksRequester = new WebhooksRequester();

const WEBHOOKS_QUERY_KEY = 'webhooks';

const useWebhooks = () => {
  const webhooksQuery = useQuery<WebhooksUpdateContent[]>({
    queryKey: [WEBHOOKS_QUERY_KEY],
    queryFn: () => webhooksRequester.getWebhooks(),
    retry: false,
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const getWebhooks = () => webhooksQuery;

  const createWebhooks = useMutation<string, unknown, { webhook: WebhooksAddContent }>({
    mutationFn: (webhookAddContent) => webhooksRequester.generateNewWebhook(webhookAddContent.webhook),
  });

  const updateWebhooks = useMutation<string, unknown, { webhook: WebhooksUpdateContent }>({
    mutationFn: (webhookUpdateContent) => webhooksRequester.updateWebhook(webhookUpdateContent.webhook),
  });

  const deleteWebhooks = useMutation<void, unknown, { id: string }>({
    mutationFn: (webhook) => webhooksRequester.revokeWebhooks(webhook.id),
  });

  const reactivateWebhooks = useMutation<void, unknown, { id: string }>({
    mutationFn: (webhook) => webhooksRequester.reactivateWebhook(webhook.id),
  });

  return {
    getWebhooks,
    createWebhooks,
    updateWebhooks,
    deleteWebhooks,
    reactivateWebhooks,
  };
};

export default useWebhooks;
export { default as useWebhookEventTypes } from './useWebhookEventTypes';
export { default as useWebhookEventTypesGrouped } from './useWebhookEventTypesGrouped';
